import {asyncType} from '../helpers';

export const synchronizationsReducerKey = 'synchronizations';

export default {
   GET_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/GET_SYNCHRONIZATION`),
   CREATE_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/CREATE_SYNCHRONIZATION`),
   MOVE_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/MOVE_SYNCHRONIZATION`),
   VALIDATE_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/VALIDATE_SYNCHRONIZATION`),
   UPDATE_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/UPDATE_SYNCHRONIZATION`),
   GET_REFS_PGP: asyncType(`${synchronizationsReducerKey}/GET_REFS_PGP`),
   GET_REFS_SSH: asyncType(`${synchronizationsReducerKey}/GET_REFS_SSH`),
   GET_REFS_SSL: asyncType(`${synchronizationsReducerKey}/GET_REFS_PGP`),
   GET_REFS_PROXY: asyncType(`${synchronizationsReducerKey}/GET_REFS_PROXY`),
   GET_REFS_PARTNER: asyncType(`${synchronizationsReducerKey}/GET_REFS_PARTNER`),
   GET_REFS_TRANSACTION: asyncType(`${synchronizationsReducerKey}/GET_REFS_TRANSACTION`),
   // GET_LINKABLE_SYNCHRONIZATIONS: asyncType(
   //    `${synchronizationsReducerKey}/GET_LINKABLA_SYNCHRONIZATIONS`
   // ),
   // GET_TROUBLESHOOTING: asyncType(`${synchronizationsReducerKey}/GET_TROUBLESHOOTING`),
   // TURN_OFF_TROUBLESHOOTING: asyncType(`${synchronizationsReducerKey}/TURN_OFF_TROUBLESHOOTING`),
   // RELEASE_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/RELEASE_SYNCHRONIZATION`),
   // SUSPEND_SYNCHRONIZATION: asyncType(`${synchronizationsReducerKey}/SUSPEND_SYNCHRONIZATION`),
   // OPEN_VALIDATE: asyncType(`${synchronizationsReducerKey}/OPEN_VALIDATE`),

   // REGISTER_FORMIK_PROPS: `${synchronizationsReducerKey}/REGISTER_FORMIK_PROPS`,
   // RESET_FORM: `${synchronizationsReducerKey}/RESET_FORM`,
   // RESET_CURRENT_FORM: `${synchronizationsReducerKey}/RESET_CURRENT_FORM`,
   // PERSIST_CURRENT_VALUES: `${synchronizationsReducerKey}/PERSIST_CURRENT_VALUES`,
};
